import { motion } from "framer-motion";

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="px-6 md:px-12 py-24 md:py-48 border-t border-white/5">
            <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
                <p className="col-span-12 md:col-span-2 text-[11px] tracking-[0.32em] uppercase text-white/45 mt-3">
                    02 — About
                </p>
                <div className="col-span-12 md:col-span-10">
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        className="font-body font-light tracking-tight text-[28px] sm:text-4xl md:text-5xl lg:text-[64px] leading-[1.1] text-white/95 max-w-6xl"
                    >
                        Creamos contenido para <span className="text-[color:var(--midi-accent-strong)]">marcas</span>,
                        plataformas y personas que quieren <em className="not-italic text-white">dejar una huella</em>.
                        <br />
                        <br />
                        Combinamos narrativa, diseño y producción para convertir una idea en una historia que
                        <span className="text-white"> merezca ser </span>
                        <span className="text-[color:var(--midi-accent-strong)]">compartida</span>.
                    </motion.h2>

                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 1.1, delay: 0.2 }}
                        className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 text-white/60"
                    >
                        {[
                            ["Direction", "Dirección creativa y cinematográfica de cada proyecto."],
                            ["Story", "Guión, estructura y voz autoral para cada formato."],
                            ["Production", "Equipo, talento y producción a medida en cualquier ciudad."],
                            ["Post", "Edición, color y diseño sonoro con sensibilidad editorial."],
                        ].map(([t, d]) => (
                            <div key={t}>
                                <p className="text-[11px] tracking-[0.32em] uppercase text-white/40 mb-3">{t}</p>
                                <p className="text-sm font-light leading-relaxed text-white/70">{d}</p>
                            </div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
